import React from 'react';

const SvgCalendar = () => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8002 0V2.4H6.2002V0H3.8002V2.4H2.6002C1.2682 2.4 0.212195 3.48 0.212195 4.8L0.200195 21.6C0.200195 22.92 1.2682 24 2.6002 24H19.4002C20.7202 24 21.8002 22.92 21.8002 21.6V4.8C21.8002 3.48 20.7202 2.4 19.4002 2.4H18.2002V0H15.8002ZM7.4 10.8H3.8V14.4H7.4V10.8ZM3.8 16.2H7.4V19.8H3.8V16.2ZM9.2 16.2H12.8V19.8H9.2V16.2ZM9.2 10.8H12.8V14.4H9.2V10.8ZM18.2 16.2H14.6V19.8H18.2V16.2ZM14.6 10.8H18.2V14.4H14.6V10.8ZM2.59941 21.6H19.3994V8.39997H2.59941V21.6Z"
      fill="url(#paint0_linear_2011_1280)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2011_1280"
        x1="8.19561e-07"
        y1="12"
        x2="11"
        y2="-6.00649e-07"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E25D34" stopOpacity="0" />
        <stop offset="1" stopColor="#E25D34" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgCalendar;
